module.exports = __webpack_public_path__ + "img/building.88209aa4.svg";